import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';

export const PRODUCT_QUERY_KEY = 'product';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseProductReturn = {
	selectedProductTypes: CheckboxItem[];
	selectedProductTypesParam: string | (string | null)[] | null | undefined;
	setSelectedProductTypesParam: (
		newValue: NewValueType<CheckboxItem[] | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useProduct = (): UseProductReturn => {
	const { permitProductTypes } = useAppSelector((state) => state.permits);

	const [selectedProductTypesParam, setSelectedProductTypesParam] = useQueryParam(PRODUCT_QUERY_KEY, ProductArrayParam);
	const selectedProducts = permitProductTypes.filter((product) =>
		selectedProductTypesParam?.includes(String(product.id))
	);

	return {
		selectedProductTypes: selectedProducts.map((product) => ({
			id: product.id,
			label: product.name
		})),
		selectedProductTypesParam,
		setSelectedProductTypesParam
	};
};

export const ProductArrayParam: QueryParamConfig<
	CheckboxItem[] | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (array) => {
		if (array == null) {
			return undefined;
		}

		const permitProducts = array.filter(Boolean).map((checkboxItem) => String(checkboxItem.id));
		const value = permitProducts.length > 0 ? permitProducts : null;
		return encodeDelimitedArray(value);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
